import { useEffect } from 'react'

export function useBodyScrollLock(shouldLock: boolean) {
	useEffect(() => {
		if (!shouldLock || typeof document === 'undefined') {
			return
		}

		const previousPosition = document.body.style.position
		document.body.style.position = 'fixed'

		return () => {
			document.body.style.position = previousPosition || 'relative'
		}
	}, [shouldLock])
}
